<template>
  <el-cascader
    class="h-40 mw-240 w-100p"
    :options="options"
    v-model="childValue"
    :filterable="filterable"
    clearable
    :show-all-levels="showAllLevels"
    :disabled="disabled"
    :props="props"
    clearable
    @input="change">
  </el-cascader>
</template>
<script>
  /**
   * @param Array value 绑定值
   * @param Number type 类型
   * @param Number id 控件id
   * @param Boolean filterable 是否可搜索选项
   * @param Boolean showAllLevels 是否显示完整值
   * @param Boolean disabled 是否禁用
   * @param Boolean areaLimit 是否开启区域限制（省市区专属）
   * @param Array areaConfig 区域限制数组（省市区专属）
   */
  import modelConfig from '../../../../config/modelConfig'
  import http from '../../../../assets/js/http'
  export default {
    props: ['value', 'type', 'id', 'filterable', 'showAllLevels', 'disabled', 'areaLimit', 'areaConfig'],
    data() {
      return {
        childValue: null,
        options: [],
        props: {
          value: 'id',
          label: 'name'
        }
      }
    },
    methods: {
      initData() {
        if (this.value && this.value.length) {
          this.childValue = this.value
        } else {
          this.childValue = []
        }
      },
      getFormData(keywords, pid) {
        return new Promise((resolve, reject) => {
          this.apiGet(`form/links/${this.id}`).then((res) => {
            if (res.code == 200) {
              if (res.data && res.data.length) {
                resolve(res.data)
              } else {
                resolve([])
              }
            } else {
              _g.toastMsg(this, 'error', res.error)
              resolve([])
            }
          })
        })
      },
      async getOptionsData() {
        switch (this.type) {
          case this.CASCADER_PROVINCE: // 省市区
            let options = []
            let cityData = []
            _g.catchError(this, () => {
              cityData = require('../../../../data/city-data.json')
            }, '没有省市区数据!')
            if (this.areaLimit && this.areaConfig) { // 有区域限制
              _(cityData).forEach((res) => {
                if (_.findIndex(this.areaConfig, (item) => {
                  return item == res.id
                }) > -1) {
                  options.push(res)
                }
              })
              this.options = options
            } else {
              this.options = cityData
            }
            break
          case this.CASCADER_SELF: // 自定义
            this.options = await this.getFormData()
            break
        }
      },
      async getChildren(value) {
        if (this.type == this.CASCADER_SELF) {
          let index = _.findIndex(this.options, (res) => {
            res.id == value
          })
          this.options[index].children = await this.getFormData()
        }
      },
      change(value) {
        this.$emit('input', value)
      }
    },
    created() {
      this.initData()
      this.getOptionsData()
    },
    watch: {
      'value'() {
        if (this.value != this.childValue) {
          this.initData()
        }
      }
    },
    mixins: [http, modelConfig]
  }
</script>


// WEBPACK FOOTER //
// honrayCascader.vue?5363b6cc